module.exports = __webpack_public_path__ + "static/media/enterpriseIcon.813db773.svg";